/**
 * Instagram pages
 *
 */
export const instagramPages = {
  onedio: { id: '5ff42d253b5dbe7941cb4630', title: '' }, // instagram.com/onediocom
  goygoy: { id: '5ff42d5105751a8a3a7e157c', title: 'Goygoy' },
  inspo: { id: '5ff42d67f34a189239308d17', title: 'Inspo' },
  iq: { id: '5ff42d5cf190805842619f86', title: 'Iq' },
  test: { id: '5ff42d44d60200b3390e1dee', title: 'Test' },
  yemek: { id: '5ff42d712b14e4c839772d2a', title: 'Yemek' },
  vitrin: { id: '60b641d127c2f3f01952bfad', title: 'Vitrin' },
  spor: { id: '60b641de27c2f3f01952bfaf', title: 'Spor' },
  gaming: { id: '61e935023f2396541b62f05f', title: 'Gaming' },
};
